var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"green","outlined":""},on:{"click":_vm.onExport}},[_vm._v("Xuất excel")])}
var staticRenderFns = []

export { render, staticRenderFns }